<template lang="pug">
  div(v-if="showForm").map-year-create
    transition
      div.small-modal.open
        div
          div.modal
            div.modal_container
              div.body-wrapper
                e-form(:formValidator="formValidator")
                  div.body
                    div.col
                      e-form-group(
                        label="Год"
                        name="year"
                        inputType="input"
                        :model="fields"
                        tabView="tab1"
                        :required="true"
                      )
                      e-form-group(
                        name="coef"
                        inputType="input"
                        label="Коэффициент накопления отходов"
                        :model="fields"
                        tabView="tab1"
                        :required="true"
                        validationRule="double"
                      )

              div.footer
                div.actions-filter-panel.actions-filter-panel--right
                  div
                    button(type="button" @click="close()").actions-filter-panel__button.standart.standart-noborder Отмена
                    button(v-if="userCanCreate" type="button" @click="sendForm()").actions-filter-panel__button.standart Добавить
</template>

<script>
    import formBaseMixin from '../../../components/form/form-base-mixin.js'
    import {map as mapEndpoints} from '../../../api/api-endpoints.js'
    import {PERMS} from '../../../config/permissions.js'

    export default {
        name: 'map-year-update',
        mixins: [formBaseMixin],
        title: false,
        data() {
            return {
                tabView: 'tab1',
                fields: {
                    year: '',
                    coef: ''
                }
            }
        },
        props: {
            showForm: {
                type: Boolean,
                required: true
            }
        },
        methods: {
            beforeSaveForm: async function () {
                if (this.userHavePermissionEx(PERMS.CREATE) === false) {
                    return Promise.reject('Нет прав')
                }
                return Promise.resolve(1)
            },
            close() {
                this.$emit('closeForm');
            },
            getUpdateOrCreateUrl() {
                return mapEndpoints.threadsSchemaCopy()
            },
        }
    }
</script>
